__turbopack_context__.v({
  "root": "Table-module__WHYl9G__root",
});
